
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/privacidade",
      function () {
        return require("private-next-pages/home/privacidade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/privacidade"])
      });
    }
  